import { render, staticRenderFns } from "./ElementWeightTableColumn.vue?vue&type=template&id=3c950e03"
import script from "./ElementWeightTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementWeightTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports